import { render, staticRenderFns } from "./CancelProcedure.vue?vue&type=template&id=0b1f0f8a&"
import script from "./CancelProcedure.vue?vue&type=script&lang=js&"
export * from "./CancelProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports